import { TPaymentScheduleStatus } from '@/shared/api';

export const getScheduleName = (status: TPaymentScheduleStatus): string => {
    switch (status) {
        case 'overdue':
            return 'Просрочен';

        case 'outstanding':
            return 'Предстоящий';

        case 'current':
            return 'Текущий';

        case 'pay_day':
            return 'День оплаты';

        case 'completed':
        default:
            return 'Оплачено';
    }
};
